<template>
  <div class="control">
    <iframe ref="mediaframe" id="mediaframe" allowfullscreen="true" allowtransparency="true" scrolling="no" :src="videoSrc + '&width=780&height=446&teaserflag=1'" width="780" height="446" frameborder="0" v-if="loginStatus.status || mainConfig.LoginPlayFlag === 0"></iframe>
    <template v-else>
      <iframe ref="mediaframe" id="mediaframe" allowfullscreen="true" allowtransparency="true" scrolling="no" :src="videoSrc + '&width=780&height=446&teaserflag=1'" width="780" height="446" frameborder="0" v-if="played"></iframe>
      <div class="pic" v-else>
        <img :src="'//img.233.com/wx/img/union/channel/playimg/' + curClass.ClassEName + '.jpg'" style="width: 780px;height: 446px; }" />
        <img src="https://img2.233.com/wx/union/pure/pc/play_icon.png" @click="toLogin" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Control",
  props: {
    videoSrc: {
      type: String,
      default: ""
    },
    curClass: {
      type: Object,
      default: () => {}
    },
    mainConfig: {
      type: Object,
      default: () => {}
    },
    loginStatus: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      played: false
    };
  },
  watch: {
    videoSrc() {
      if (!(this.loginStatus.status || this.mainConfig.LoginPlayFlag === 0)) {
        this.played = true;
        setTimeout(() => {
          this.played = false;
        });
      }
    }
  },
  methods: {
    toLogin() {
      window.location.href = window.location.origin + "/uc/login?redirecturl=" + window.location.href;
    }
  }
};
</script>

<style lang="scss" scoped>
.control {
  width: 780px;
  height: 100%;
  .pic {
    position: relative;
    height: 446px;
    img {
      position: absolute;
      vertical-align: top;
      &:nth-child(1) {
        top: 0;
        left: 0;
      }
      &:nth-child(2) {
        top: calc(50% - 25px);
        left: calc(50% - 25px);
        width: 50px;
        height: 50px;
        cursor: pointer;
      }
    }
  }
}
</style>
